import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Header = styled.div`  
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: ${theme.colors.blue};
  border-bottom: 1px solid ${theme.colors.lightBlue};
  margin: 16px 0;
`

export const Inline = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`
